<template lang='html'>
  <form class='test_question'>
    <div>{{question.quest}}</div>
    <span>{{question.condition}}</span>
    <answer-option v-for='answer, index in question.answers' :answer='answer' :key='index' @onSelectAnswer='handlerSelectAnswer'></answer-option>
    <input type='text' name='answer' v-if='!question.answers' @input='selectInputAnswer($event.target.value)'>
  </form>
</template>

<script>
import axios from 'axios';
import AnswerOption from './AnswerOption';

export default {
  name: 'question',

  props: {
    question: {
      type: Object
    }
  },

  methods: {
    handlerSelectAnswer(answer){
      this.question.answer = answer;
      this.$emit('onAnswer', {
        question: this.question
      })
    },
    selectInputAnswer(answer){
      this.question.answer = answer;
      this.$emit('onAnswer', {
        question: this.question
      })
    }
  },

  components: { AnswerOption },

  mounted() {
  }
}
</script>

<style lang='scss'>
  $blue: #00bcc6;
  $orange: #f7941d;

 .test_question {
    width: 100%;
    color: #555555;
    margin: 30px 0;
  }

  .test_question > div {
    border-left: 10px solid $blue;
    padding: 0 calc(5% - 10px);
    font-weight: 400;
  }

  .test_question > span {
    display: block;
    padding: 0 5%;
    color: #9a9c9f;
    font-size: 12px;
}

  .test_question > label {
    display: flex;
    margin: 15px 5%;
    cursor: pointer;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
  }

  .test-wrapper .test_question {
    border: 0 !important;
    padding: 15px 0 !important;
  }

  .test_question input {
      border: 1px solid #ccf2f4;
      font: 300 16px/20px "Fira Sans", sans-serif;
      color: #2b3138;
      vertical-align: top;
      margin-left: 30px;
      margin-top: 10px;
      padding: 9px 19px;
      width: 90%;
      height: 40px;
      box-sizing: border-box;
      outline: none;
      border-radius: 3px;
      background: #fff;
      -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Question.vue